import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { addComment } from '@/actions/comment';
import ShoppingCommentPost from '@/components/shoppings/ShoppingCommentPost';
import useUser from '@/hooks/useUser';
import { callAuth } from '@/lib/firebase/auth';
import { IShopping } from '@/@types/generated/contentful';

type ComponentProps = {
  shopping: IShopping;
};

const ShoppingCommentPostContainer: React.FC<ComponentProps> = ({ shopping }) => {
  const { id } = shopping.fields;
  const dispatch = useDispatch();
  const user = useUser();
  const handleRequestAuth = useCallback((snsType) => {
    callAuth(snsType);
  }, []);
  const handleRequestSubmit = useCallback(
    (message) => {
      if (user) dispatch(addComment({ postId: id, userId: user.uid, message }));
    },
    [dispatch, id, user]
  );

  return (
    <ShoppingCommentPost
      user={user}
      onRequestAuth={handleRequestAuth}
      onRequestSubmit={handleRequestSubmit}
    />
  );
};

export default ShoppingCommentPostContainer;
